import {
  UserComment,
  UserCommentWithRepliesSearchResult,
  UserCommentSearchFilter,
  UserCommentSearchResult,
} from '@rygen/rygen-ui/model';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'order';

export class OrderCommentController extends BaseHttpController {
  constructor() {
    super(endpoint);
  }

  async findCommentsForOrder(
    orderId: number,
    searchQuery: UserCommentSearchFilter,
  ): Promise<UserCommentWithRepliesSearchResult> {
    const response = await this.http.post(
      `${orderId}/comment/search`,
      searchQuery,
    );
    return new UserCommentWithRepliesSearchResult(response.data);
  }

  async findRepliesForComment(
    orderId: number,
    commentId: number,
    searchQuery: UserCommentSearchFilter,
  ): Promise<UserCommentSearchResult> {
    const response = await this.http.post(
      `${orderId}/comment/${commentId}/reply/search`,
      searchQuery,
    );
    return new UserCommentSearchResult(response.data);
  }

  async createComment(
    orderId: number,
    content: Record<string, unknown>,
  ): Promise<UserComment> {
    const payload = { content };
    const response = await this.http.post<UserComment>(
      `${orderId}/comment`,
      payload,
    );
    return new UserComment(response.data);
  }

  async replyToComment(
    orderId: number,
    commentId: number,
    content: Record<string, unknown>,
  ): Promise<UserComment> {
    const payload = { content };
    const response = await this.http.post<UserComment>(
      `${orderId}/comment/${commentId}/reply`,
      payload,
    );
    return new UserComment(response.data);
  }

  async updateComment(
    orderId: number,
    commentId: number,
    content: Record<string, unknown>,
  ): Promise<UserComment> {
    const payload = { content };
    const response = await this.http.put<UserComment>(
      `${orderId}/comment/${commentId}`,
      payload,
    );
    return new UserComment(response.data);
  }

  async deleteComment(orderId: number, commentId: number): Promise<void> {
    await this.http.delete(`${orderId}/comment/${commentId}`);
  }
}
